import { render, staticRenderFns } from "./ModalChangePlan.vue?vue&type=template&id=6c629596&scoped=true&"
import script from "./ModalChangePlan.vue?vue&type=script&lang=ts&"
export * from "./ModalChangePlan.vue?vue&type=script&lang=ts&"
import style0 from "./ModalChangePlan.vue?vue&type=style&index=0&id=6c629596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c629596",
  null
  
)

export default component.exports